(function (app) {

    app.controller("addContactController", addContactController);

    function addContactController($q, $state, $mdDialog, clientApi, advisorApi, personApi) {
        const $ctrl = this;

        $ctrl.$onInit = () => {
            $ctrl.client = {};
            $ctrl.loading = true;

            const promises = [
                clientApi.getClientTypes(),
                advisorApi.getCurrentUserParentAdvisors()
            ];

            $q.all(promises).then(responses => {
                $ctrl.clientTypes = responses[0];
                $ctrl.advisors = responses[1];

                // if the current user is an advisor make them the primaryadvisor
                if (!!$ctrl.currentUser.AdvisorId && $ctrl.currentUser.AdvisorId !== "00000000-0000-0000-0000-000000000000") {
                    $ctrl.client.PrimaryAdvisorId = $ctrl.currentUser.AdvisorId;

                    $ctrl.client.PrimaryAdvisor = {
                        Id: $ctrl.currentUser.AdvisorId,
                        Person: {
                            FirstName: $ctrl.currentUser.FirstName,
                            LastName: $ctrl.currentUser.LastName,
                        }
                    };

                    // set current user to first advisor in advisor's list
                    $ctrl.advisors.unshift($ctrl.client.PrimaryAdvisor);
                }

                $ctrl.loading = false;
            });            
        };

        $ctrl.close = () => {
            $mdDialog.hide();
        };

        $ctrl.searchAdvisors = (term) => {
            return advisorApi.searchAdvisors(term).then(advisors => advisors);
        };

        $ctrl.createClient = (client, event) => {
            $ctrl.loading = true;

            client.PrimaryAdvisorId = client.PrimaryAdvisor.Id;

            return clientApi.add(client)
                .then(clientRes => {
                    //if no email is specified
                    if (!client.Person.PrimaryEmail) {
                        $ctrl.close(event);
                        return $state.go("Home.Client", { clientId: clientRes.Id });
                    }

                    //otherwise add email & set to primary 
                    let email = {
                        Type: "Personal",
                        Preferred: true,
                        Value: client.Person.PrimaryEmail
                    };

                    return personApi.addEmailAddress(clientRes.Id, email)
                        .then(emailRes => {
                            return personApi.updatePrimaryEmailAddress(clientRes.Id, emailRes);
                        })
                        .then(() => {
                            $ctrl.close(event);
                            return $state.go("Home.Client", { clientId: clientRes.Id });
                        });
                })
                .catch(error => { console.log(error); })
                .finally(() => {
                    $ctrl.loading = false;
                });
        };
    }
})(window.app);